import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Experiences from './components/Experiences';
import LuxuryPackages from './components/LuxuryPackages';
import WhyUs from './components/WhyUs';
import CustomiseTrip from './components/CustomiseTrip';
import Reviews from './components/Reviews';
import { Routes, Route } from 'react-router-dom';
import BookWithUs from './pages/BookWithUs';
import SelfBooking from './pages/SelfBooking';
import LuxuryPackagesPage from './pages/LuxuryPackagesPage';
import WhyLuxTripsPage from './pages/WhyLuxTripsPage';
import Contacts from './pages/Contacts';
import RustTest from './pages/RustTest';
import SiteFooter from './components/SiteFooter';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={(
          <>
            <Hero />
            <Experiences />
            <LuxuryPackages />
            <WhyUs />
            <CustomiseTrip />
            <Reviews />
            {/* Убираем ContactFooter с главной, чтобы не было двух футеров */}
          </>
        )} />
        <Route path="/book" element={<><Header /><BookWithUs /></>} />
        <Route path="/self-booking" element={<><Header /><SelfBooking /></>} />
        <Route path="/packages" element={<><Header /><LuxuryPackagesPage /></>} />
        <Route path="/why" element={<><WhyLuxTripsPage /></>} />
        <Route path="/contact" element={<Contacts />} />
        {/* Скрытая тестовая страница — без ссылок в меню */}
        <Route path="/rusttest" element={<RustTest />} />
      </Routes>
      <SiteFooter />
    </div>
  );
}

export default App;